import { ShimmerBox } from '@app/_components/shimmer-box';
import { css } from '@styled-system/css';
import { HStack, VStack, VstackProps } from '@styled-system/jsx';

export type Visibilities = Partial<{
  noBackground: boolean;
  noTags: boolean;
  noUser: boolean;
}>;

export type SeriesListPlaceholderItemConfigs = Partial<{
  visibilities: Visibilities;
}>;

type Props = {
  config?: SeriesListPlaceholderItemConfigs;
} & VstackProps;

export const DefaultConfigs: SeriesListPlaceholderItemConfigs = {
  visibilities: {
    noBackground: false,
    noTags: true,
    noUser: true,
  },
};

export const SeriesListPlaceHolderItem = ({
  config,
  ...vstackProps
}: Props) => {
  const configs = {
    ...DefaultConfigs,
    ...config,
  };

  return (
    <VStack
      overflow="hidden"
      cursor="pointer"
      color="accent.700"
      background={
        configs.visibilities?.noBackground === true ? 'none' : 'surface_primary'
      }
      position="relative"
      w="100%"
      px="4"
      py="3"
      lg={{
        _hover: {
          bg:
            configs.visibilities?.noBackground === true ? 'none' : 'highlight',
        },
      }}
      gap="4"
      alignItems="flex-start"
      borderBottom={{
        base: '1px solid token(colors.separator)',
        lg: 'none',
      }}
      _lastOfType={{
        borderBottom: 'none',
      }}
      className={css({
        '& a:hover': {
          opacity: '0.8',
        },
      })}
      {...vstackProps}
    >
      <HStack gap="3" w="100%" alignItems="flex-start">
        <ShimmerBox w="132px" h="88px" borderRadius="3px" flexShrink={0} />

        <VStack gap="1" w="100%">
          <ShimmerBox w="100%" h="42px" borderRadius="2px" />
          <ShimmerBox w="100%" h="20px" borderRadius="2px" />
        </VStack>
      </HStack>

      {(configs.visibilities?.noTags === false ||
        configs.visibilities?.noUser === false) && (
        <VStack gap="2" alignItems="flex-start">
          {configs.visibilities?.noTags === false && (
            <HStack>
              <ShimmerBox w="70px" h="18px" borderRadius="2px" />
              <ShimmerBox w="40px" h="18px" borderRadius="2px" />
              <ShimmerBox w="60px" h="18px" borderRadius="2px" />
              <ShimmerBox w="90px" h="18px" borderRadius="2px" />
            </HStack>
          )}
          {configs.visibilities?.noUser === false && (
            <ShimmerBox w="40%" h="18px" borderRadius="2px" />
          )}
        </VStack>
      )}
    </VStack>
  );
};
